import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { ClientServiceSelectionComponent } from './client-service-selection.component';
import { RecordCommentModule } from 'app/main/content/global-component/control-template/record-comment/record-comment.module';
import { ProcessStatusModule } from 'app/main/content/global-component/control-template/process-status/process-status.module';

@NgModule({
  declarations: [
      ClientServiceSelectionComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FuseSharedModule,
    RecordCommentModule,
    ProcessStatusModule
  ],
  entryComponents: [
    
  ],
  exports: [
    ClientServiceSelectionComponent
  ]
})
export class ClientServiceSelectionModule { }
